import { z } from 'zod';
export const createBusinessSchema = z.object({
    type: z.enum(['business', 'non_profit']).default('business'),
    country: z.enum(['US', 'CA']).default('US'),
    legal_name: z.string().min(1).max(255),
    dba_name: z.string().max(255).optional(),
    ein: z.string().max(20)
        .refine(val => !val || /^\d{2}-\d{7}$/.test(val), {
        message: 'EIN must be XX-XXXXXXX format (9 digits)',
    })
        .optional(),
    bn: z.string().max(20).optional(),
    gst_hst_number: z.string().max(20).optional(),
    state_province: z.string().max(50).optional(),
    business_structure: z.enum(['llc', 'corporation', 'sole_proprietorship', 'partnership', 'non_profit', 'other']).optional(),
    address_line1: z.string().max(255).optional(),
    address_line2: z.string().max(255).optional(),
    city: z.string().max(100).optional(),
    state: z.string().max(50).optional(),
    postal_code: z.string().max(20).optional(),
    address_country: z.string().length(2).default('US'),
    billing_contact_name: z.string().max(255).optional(),
    billing_email: z.string().email().max(254).optional(),
    billing_phone: z.string().max(20)
        .refine(val => !val || /^\(\d{3}\) \d{3}-\d{4}$/.test(val), {
        message: 'Phone must be (XXX) XXX-XXXX format',
    })
        .optional(),
    tax_exempt: z.boolean().default(false),
    currency: z.enum(['USD', 'CAD']).default('USD'),
    is_default: z.boolean().default(false),
});
export const updateBusinessSchema = createBusinessSchema.partial();
export const BUSINESS_STRUCTURES = [
    { value: 'llc', label: 'LLC' },
    { value: 'corporation', label: 'Corporation' },
    { value: 'sole_proprietorship', label: 'Sole Proprietorship' },
    { value: 'partnership', label: 'Partnership' },
    { value: 'non_profit', label: 'Non-Profit' },
    { value: 'other', label: 'Other' },
];
//# sourceMappingURL=business.js.map